import { render, staticRenderFns } from "./FaturamentoEvolucaoSupervisorVendas.vue?vue&type=template&id=35fa8d5e&scoped=true&"
import script from "./FaturamentoEvolucaoSupervisorVendas.vue?vue&type=script&lang=js&"
export * from "./FaturamentoEvolucaoSupervisorVendas.vue?vue&type=script&lang=js&"
import style0 from "./FaturamentoEvolucaoSupervisorVendas.vue?vue&type=style&index=0&id=35fa8d5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fa8d5e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VContainer,VIcon})
